import {SNACK_ACTION} from '@/_store/snackbar';
import {store} from '@/_store';
import {ACCOUNT_ACTION} from "@/_store/account";
import { api } from '@/_store/api';

export function getTokenFromCookie() {
    return (window as any).$cookies.get('token');
}

export function getTokenDateFromCookie() {
    return (window as any).$cookies.get('tokenDate');
}

export function authHeader(): any {
    const token: string = getTokenFromCookie();

    if (token) {
        return {Authorization: 'Bearer ' + token };
    } else {
        return {};
    }
}

export async function handleResponse(response: any): Promise<any> {
    switch (response.status) {
        case 404:
        case 500:
            store.dispatch(SNACK_ACTION.ERROR, 'Unable to perform action. Please contact an administrator.');
            return null;
        case 401:
            store.dispatch(ACCOUNT_ACTION.LOGOFF);
            return null;
        case 400:
            const msg = await response.text();
            store.dispatch(SNACK_ACTION.ERROR, msg);
            return null;
    }
    return await response.json();
}

export async function handleError(error: any): Promise<any> {
    store.dispatch(SNACK_ACTION.ERROR, 'Unable to perform action. Please contact an administrator.');
}


export async function getApiUrl() {
    if (!api.state.url) {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}variables.js`);
        const v = await response.json();
        await store.dispatch('api/setUrl', v.API_URL);
    }
    return api.state.url;
}
